import { render, staticRenderFns } from "./allorder.vue?vue&type=template&id=260c7aee&scoped=true"
import script from "./allorder.vue?vue&type=script&lang=js"
export * from "./allorder.vue?vue&type=script&lang=js"
import style0 from "./allorder.vue?vue&type=style&index=0&id=260c7aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c7aee",
  null
  
)

export default component.exports